import { render, staticRenderFns } from "./peopleinfo.vue?vue&type=template&id=027e74d8&scoped=true&"
import script from "./peopleinfo.vue?vue&type=script&lang=js&"
export * from "./peopleinfo.vue?vue&type=script&lang=js&"
import style0 from "./peopleinfo.vue?vue&type=style&index=0&id=027e74d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e74d8",
  null
  
)

export default component.exports